require("!!/app/node_modules/script-loader/addScript.js")(require("!!/app/node_modules/raw-loader/index.js!/app/node_modules/file-saver/FileSaver.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/file-saver/FileSaver.js
// module id = 968
// module chunks = 0